var React = require('react');

function StarRating (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M19.5 0L24.1034 15.2779H39L26.9492 24.7202L31.5526 40L19.5 30.5558L7.44744 40L12.0508 24.7202L0 15.2779H14.8966L19.5 0Z","fill":"#FFDC22"}));
}

StarRating.defaultProps = {"width":"39","height":"40","viewBox":"0 0 39 40","fill":"none"};

module.exports = StarRating;

StarRating.default = StarRating;
